import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MatchCities } from '../interfaces/match-cities.interface';
import { City } from '../interfaces/city.interface';
import { Street } from '../interfaces/street.interface';
import { WhatToClear } from '../interfaces/what-to-clear.interface';
import { ErrorDisplayManagerService } from './error-display-manager.service';



@Injectable({
  providedIn: 'root'
})
export class CallAPIService {

  private subscribedCityInputs = {};
  inputs = {};
  validityChanged: EventEmitter<{ inputID: string, isValid: boolean, description: string }>;

  private onlyValidCity: boolean;
  private countCloseCities: 0;

  private closeCitiesByName = [];
  private responseCities = [];

  private postOfficeInfo = new BehaviorSubject(undefined);
  private postoffices = {};
  private streetsInfo = new BehaviorSubject(undefined);
  private streetsByPostIndex = new BehaviorSubject(undefined);
  public api_url: string; //= document.location.origin.includes('localhost') ? 'https://dev-index.ukrposhta.loc/endpoints-for-apps/index.php' : document.location.origin + '/endpoints-for-apps/index.php'; // 'https://index.ukrposhta.ua/endpoints-for-apps/index.php';

  private isBuildForProd: boolean = true;

  private cityPostIndex = {
    fromWhere: '',
    //fromWhereCityName: '',
    toWhere: '',
    //toWhereCityName: ''
  };

  private initCities = {
    fromWhereCityName: '',
    toWhereCityName: ''
  };

  private citiesNames = new BehaviorSubject(this.initCities)
  private choosenCity = new BehaviorSubject(undefined);
  private streets = new BehaviorSubject(undefined);
  private houses = new BehaviorSubject(undefined);
  private schedule = new BehaviorSubject(undefined);

  private clearResponses = new BehaviorSubject<WhatToClear>(undefined);


  constructor(
    private http: HttpClient,
    private errorDisp: ErrorDisplayManagerService,
  ) {
    this.validityChanged = new EventEmitter<{ inputID: string, isValid: boolean, description: string }>();
    this.choosenCity.subscribe((newCity) => {
      if (newCity != undefined) {
        //this.getStreetsForCity( newCity );
        //this.sendRequestForCitiesByPrefix

      }
    });

    this.addInputCityToSubscribers('toWhere');

    this.clearResponses.subscribe((clear: WhatToClear) => {
      this.executeClearWithConfig(clear);
    })

    if (document.location.origin.includes('localhost'))
      this.api_url = 'https://dev-index.ukrposhta.loc/endpoints-for-apps/index.php';
    else
      this.api_url = document.location.origin + '/endpoints-for-apps/index.php';

    //console.log(this.api_url, window.location.hostname)
  }

  public buildClearConfig(city: boolean = false, street: boolean = false, house: boolean = false, schedule: boolean = false, response: boolean = false): WhatToClear {
    return {
      toClearCity: city,
      toCleatStreet: street,
      toClearHouse: house,
      toClearSchedule: schedule,
      toClearResponse: response
    }
  }

  public executeClearWithConfig(clear: WhatToClear) {
    if (clear) {
      if (clear.toClearCity)
        this.subscribedCityInputs['toWhere'].next({});
      if (clear.toClearResponse) {
        this.choosenCity.next(null);
        this.postOfficeInfo.next(null);
      }
      if (clear.toCleatStreet)
        this.streets.next([]);
      if (clear.toClearHouse)
        this.houses.next([]);
      if (clear.toClearSchedule)
        this.schedule.next([]);


    }

  }

  public getClearSubject() {
    return this.clearResponses
  }


  public getScheduleObservable() {
    return this.schedule.asObservable();
  }


  public getObservableForeSingleMachingCity() {
    return this.choosenCity.asObservable();
  }


  public getStreetsObservable() {
    return this.streets.asObservable()
  }

  public pushNewStreets(newStreets) {
    this.streets.next(newStreets)
  }

  public getHousesObservable() {
    return this.houses.asObservable()

  }

  public pushNewHouses(newHouses) {
    this.houses.next(newHouses)
  }

  public getObservablePostOfficeInfo() {
    return this.postOfficeInfo.asObservable();
  }

  public getObservableStreetsInfo() {
    return this.streetsInfo.asObservable();
  }

  public getObservableStreetsByIndex() {
    return this.streetsByPostIndex.asObservable();
  }

  getObservableCityByInputID(inputID: string) {
    return this.subscribedCityInputs[inputID].asObservable();
  }

  public getFromWhereCityName() {
    return this.citiesNames.value.fromWhereCityName;
  }

  public getToWhereCityName() {
    return this.citiesNames.value.toWhereCityName;
  }

  public clearIndexCityToWhere() {
    this.cityPostIndex.toWhere = '';

  }

  public clearIndexCityFromWhere() {
    this.cityPostIndex.fromWhere = '';

  }

  public sendRequestForCitiesByPrefix(city_prefix: string): any {

    //city_prefix = this.replaceToSQLApostraph( city_prefix );

    let address = this.isBuildForProd ?
      this.api_url + '?method=get_city_by_region_id_and_district_id_and_city_ua&city_ua=' + city_prefix :
      'https://www.ukrposhta.ua/address-classifier/get_city_by_region_id_and_district_id_and_city_ua&city_ua=' + city_prefix;

    this.http.get(address)  // , httpOptions
      .subscribe((cities: any) => {
        if (cities.Entries != {}) {

          if (cities.Entries)
            this.responseCities = cities.Entries.Entry;

          if (cities.Entry)
            this.responseCities = cities.Entry;

          if (cities && cities.length == 0) {
            this.subscribedCityInputs['toWhere'].next(
              {
                cities: [],
                citiesCount: 0,
                controlID: 'toWhere',
                cityPrefix: city_prefix,
                isPrefixMatchOnlyOneCity: false
              });
            this.setInvalid('toWhere', "no matches");
            return;
          }
          if (this.responseCities && this.responseCities.sort)
            this.responseCities.sort((a: any, b: any) => {

              let result = Number.parseInt(b.POPULATION) - Number.parseInt(a.POPULATION) < 0 ? -1 : Number.parseInt(b.POPULATION) == Number.parseInt(a.POPULATION) ? 0 : 1;

              return result;
            })

          this.callWhenCitiesResponceBack(this.responseCities, city_prefix, 'toWhere');

          this.subscribedCityInputs['toWhere'].next(
            {
              cities: this.closeCitiesByName,
              citiesCount: this.countCloseCities,
              controlID: 'toWhere',
              cityPrefix: city_prefix,
              isPrefixMatchOnlyOneCity: this.onlyValidCity
            });



        } else {
          // not valid


        }
      });

  }



  public callWhenCitiesResponceBack(cities: City[], prefix: string, inputName: string) {

    //prefix = prefix[0] != undefined ? prefix[0].toLocaleUpperCase()+prefix.slice(1) : '' ;
    prefix = (prefix != undefined && prefix != '') ? prefix.toLocaleLowerCase() : '';
    inputName = 'toWhere';

    // delete items from previous calls
    this.closeCitiesByName = [];
    this.countCloseCities = 0;
    let citiesNames = [];



    if (cities != undefined) {

      cities = this.unwrapResponseToArray(cities);

      for (let city of cities) {

        if (city.CITY_UA.toLocaleLowerCase().includes(prefix)) {

          citiesNames.push(city.CITY_UA);

          if (this.isNotDublicateCity(this.closeCitiesByName, city)) {

            this.closeCitiesByName.push({
              CITY_ID: city.CITY_ID,
              CITY_UA: city.CITY_UA,
              DISTRICT_ID: city.DISTRICT_ID,
              REGION_ID: city.REGION_ID,
              DISTRICT_UA: city.DISTRICT_UA,
              REGION_UA: city.REGION_UA,
              CITYTYPE_UA: city.CITYTYPE_UA,
              SHORTCITYTYPE_UA: city.SHORTCITYTYPE_UA
            });

            ++this.countCloseCities;
          }
        }
      }


      this.onlyValidCity = this.onlyOneMatchString(citiesNames, prefix) //== 1 ? true : false ;
      prefix = prefix != undefined ? prefix.toLocaleLowerCase() : '';

      if (this.closeCitiesByName.length == 0) {


        this.setInvalid(inputName, "no matches");

      }
      if (this.closeCitiesByName.length == 1) {


        if (this.onlyValidCity) {
          if (this.closeCitiesByName[0].CITY_UA.toLocaleLowerCase() == prefix) {
            this.setValid(inputName, 'match only one city');
            // call city post code

            this.choosenCity.next(this.closeCitiesByName[0]);


          } else
            this.setInvalid(inputName, 'names not match for only one city');

        } else
          this.setInvalid(inputName, 'not match only one city');

      }
      if (this.closeCitiesByName.length > 1) {


        this.setInvalid(inputName, 'match couple cities');

      }

    }

  }

  public sendRequestForHouses(street): any {

    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': ''
      })
    };
    let address = this.isBuildForProd ?
      this.api_url + `?method=get_addr_house_by_street_id&street_id=${street.STREET_ID}&housenumber=` :
      `https://www.ukrposhta.ua/address-classifier/get_addr_house_by_street_id?street_id=${street.STREET_ID}&housenumber=`;

    this.http.get(address)
      .subscribe((houses: any) => {

        houses = this.unwrapResponseToArray(houses)
        if (houses != undefined)
          this.pushNewHouses(houses);

      });

  }

  public unwrapResponseToArray(some: any): [any] {

    if (some && !some.Entry && !some.Entries && some.length && some.length > 0)
      return some;

    let result;

    if (some && some.Entry)
      result = some.Entry

    if (some && some.Entries && some.Entries.Entry)
      result = some.Entries.Entry

    if (some == undefined ||
      (Array.isArray(some) && (some.length == 0)))
      return undefined;

    if (some && (typeof some) == 'object' && !some.Entry && !some.Entries)
      return [some]

    if (result && !Array.isArray(result) || (typeof result) == 'object' && !result.length)
      result = [result]

    return result;
  }


  public sendRequestIndexByCity(cityObj: City): any {

    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': ''
      })
    };

    let address = this.isBuildForProd ?
      this.api_url + `?method=get-indexes-by-city-id&city_id=${cityObj.CITY_ID}` :
      'https://www.ukrposhta.ua/address-classifier/get_postcode_by_city_id?city_id=' + cityObj.CITY_ID;

    // getIndexesByCityID
    // let address = 'https://ukrposhta.ua/address-classifier/get_postcode_by_city_id?city_id=' + cityObj.CITY_ID ;

    this.http.get(address)
      .subscribe((recievedIndexesOfCity: any) => {

        let indexesOfCity: Array<{ CITY_ID: string, POSTCODE: string }> = this.unwrapResponseToArray(recievedIndexesOfCity)

        if (!this.isEmptyObject(indexesOfCity)) {
          let isCityHaveOneIndex;
          let prevIndex = indexesOfCity[0]

          if (indexesOfCity && indexesOfCity instanceof Array && indexesOfCity.length > 1) {
            for (let currentIndex of indexesOfCity) {
              if (currentIndex.POSTCODE != prevIndex.POSTCODE) {
                isCityHaveOneIndex = false;
                break;
              }
              isCityHaveOneIndex = true;
            }
          }

          if (indexesOfCity && indexesOfCity instanceof Array && indexesOfCity.length == 1)
            isCityHaveOneIndex = true;

          if (indexesOfCity && indexesOfCity instanceof Array && indexesOfCity.length == 0) {

          }

          if (isCityHaveOneIndex) {
            this.getPostOfficeInfoByIndex(indexesOfCity[0].POSTCODE as unknown as number);
            this.sendRequestForStreets(cityObj)

          } else {
            this.sendRequestForStreets(cityObj)

          }

        }
      });

  };

  public sendRequestForStreets(cityObj: City): any {

    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': ''
      })
    };

    let address = this.isBuildForProd ?
      this.api_url + `?method=get_street_by_region_id_and_district_id_and_city_id_and_street_ua&region_id=${cityObj.REGION_ID}&district_id=${cityObj.DISTRICT_ID}&city_id=${cityObj.CITY_ID}&street_ua=` :
      `https://www.ukrposhta.ua/address-classifier/get_street_by_region_id_and_district_id_and_city_id_and_street_ua?region_id=${cityObj.REGION_ID}&district_id=${cityObj.DISTRICT_ID}&city_id=${cityObj.CITY_ID}&street_ua=`;

    this.http.get(address)
      .subscribe((streetsResp: any) => {

        let streets: Array<Street> = this.unwrapResponseToArray(streetsResp)

        if (!this.isEmptyObject(streets)) {

          for (let street of streets) {
            street.haveOldStreetName = (street.OLDSTREET_UA.trim) ? true : false;

          }

          if (Array.isArray(streets)) {

            this.pushNewStreets(streets);
          } else {
            this.pushNewStreets([streets]);

          }

        }
      });

  };


  private onlyOneMatchString(cityNames: string[], cityNamePrefix: string) {
    let count = 0;
    for (let currentCityName of cityNames) {

      if (currentCityName.toLocaleLowerCase() == cityNamePrefix.toLocaleLowerCase())
        ++count;

    }
    if (count == 1)
      return true

    return false
  }


  public isNotDublicateCity(cities: Array<City>, candidate: City): boolean {

    for (let currentCity of cities) {

      if ((candidate.CITY_UA == currentCity.CITY_UA && candidate.CITY_ID == currentCity.CITY_ID && candidate.DISTRICT_ID == currentCity.DISTRICT_ID && candidate.REGION_ID == currentCity.REGION_ID)) {

        return false;
      }

    }
    return true;
  }


  public isEmptyObject(obj: object) {
    if (obj == undefined)
      return true;
    return Object.keys(obj).length === 0 && obj.constructor === Object
  }

  public setInvalid(inputID: string, validatorDescript: string) {
    this.inputs[inputID] = false;
    this.validityChanged.emit({ inputID: inputID, isValid: false, description: validatorDescript })

  }

  public setValid(inputID: string, validatorDescript: string) {
    this.inputs[inputID] = true;
    this.validityChanged.emit({ inputID: inputID, isValid: true, description: validatorDescript })

  }

  public isValid(inputID: string) {
    if (this.inputs[inputID]) {
      return this.inputs[inputID];
    } else {
      return undefined;
    }
  }

  public addInput(inputID: string) {
    if (!this.inputs[inputID]) {
      this.inputs[inputID] = new BehaviorSubject<boolean>(false);
    }

  }

  public getInput(inputID: string) {
    if (this.inputs[inputID]) return this.inputs[inputID].asObservable();
    else return undefined;
  }

  public getPostOfficeInfoByIndex(postCode: number) {

    this.postoffices = {};
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': ''
      })
    };
    let address = this.isBuildForProd ?
      this.api_url + '?method=get_postoffices_postdistricts_web&pc=' + postCode :
      'https://www.ukrposhta.ua/address-classifier/get_postoffices_by_postindex?pc=' + postCode; // get_postoffices_by_postindex
    this.http.get(address).subscribe((resp: any) => {

      resp = this.unwrapResponseToArray(resp)
      // console.log(resp);
      if (resp) {

        for (let i = 0; i < resp.length; ++i) {
          this.postoffices[resp[i].ID] = resp[i];
        }
        if(resp[0].TYPE_ACRONYM == 'ПВ' || resp[0].LOCK_UA.includes("ПВПЗ")){
          this.getScheduleVpzById(resp[0].ID, postCode);
        } else {
          this.getPostOfficeScheduleByIndex(postCode);
        }

      } else {
        this.postOfficeInfo.next([{}]) // error : true

      }

    });
    // console.log(address);
  }

  public getPostOfficeByIndex(postCode: number) {

    this.postoffices = {};
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': ''
      })
    };
    let address = this.isBuildForProd ?
      this.api_url + '?method=get_postoffices_by_postindex_web&pc=' + postCode :
      'https://www.ukrposhta.ua/address-classifier/get_postoffices_by_postindex_web?pc=' + postCode; // get_postoffices_by_postindex
    this.http.get(address).subscribe((resp: any) => {

      resp = this.unwrapResponseToArray(resp)
      // console.log(resp);
      if (resp) {

        for (let i = 0; i < resp.length; ++i) {
          this.postoffices[resp[i].ID] = resp[i];
        }
        this.getPostOfficeScheduleByIndex(postCode)

      } else {
        this.postOfficeInfo.next([{}]) // error : true

      }

    });
    // console.log(address);
  }

  public getIndexByCityStreetHouse(ct_name: string, st_name: string, house: number) {

    // this.postoffices = {};
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': ''
      })
    }; 
    let address =
     this.isBuildForProd ? 
      // `https://ecom-ei-k8s-prod.ukrposhta.loc/services/ECOM_API_PROD/get_postoffice_by_address?ct_name=${ct_name}&st_name=${st_name}&house=${house}&lang=UA` :

      this.api_url + `?method=get_postoffice_by_address&ct_name=${ct_name}&st_name=${st_name}&house=${house}&lang=UA` :
     `http://10.255.102.216:8280/services/ECOM_API_PROD/get_postoffice_by_address?ct_name=${ct_name}&st_name=${st_name}&house=${house}&lang=UA`;
    this.http.get(address).subscribe((resp: any) => {

      let postIndex = this.unwrapResponseToArray(resp)
      // console.log(postIndex[0].INDEX_PO);

        this.getPostOfficeByIndex( postIndex[0].INDEX_PO);

    });

  }

  public getPostOfficeScheduleByIndex(postCode: number) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': ''
      })
    };
    let address = this.isBuildForProd ?
      this.api_url + `?method=get_postoffices_openhours_by_postindex&id=${postCode}` :
      `https://www.ukrposhta.ua/address-classifier/get_postoffices_openhours_by_postindex?id=${postCode}&id=`;

    this.http.get(address)
      .subscribe((resp: any) => {
        let schaduleDays = this.unwrapResponseToArray(resp);
        let resultOfficesArray = [];

        if (schaduleDays) {
          this.schedule.next(schaduleDays)
          let schedulesForPostOffices = {}
          let breakTimeDays = [];

          let W_timeDays = schaduleDays.filter(day => {
            return day.INTERVALTYPE == 'W'
          }) || [];

          let D_timeDays = schaduleDays.filter(day => {
            return day.INTERVALTYPE == 'D' && day.TFROM.trim() != "00:00".trim() && day.TTO.trim() != "00:00".trim() // shity data check
          }) || [];


          for (let i = 0; i < W_timeDays.length; ++i) {

            if (!schedulesForPostOffices.hasOwnProperty(W_timeDays[i].id)) {
              schedulesForPostOffices[W_timeDays[i].id] = [];
            }


            // find break for current day of week
            let respectiveBreak = D_timeDays.find(day => day.DAYOFWEEK_SHORTNAME_UA.trim() == W_timeDays[i].DAYOFWEEK_SHORTNAME_UA.trim())
            if (respectiveBreak)
              W_timeDays[i].break = "(" + respectiveBreak.TFROM + " - " + respectiveBreak.TTO + ")"
            schedulesForPostOffices[W_timeDays[i].id].push(W_timeDays[i])

          }

          // add schedule to postoffice object
          for (let i = 0; i < Object.keys(schedulesForPostOffices).length; ++i) {
            let currentOfficeId = Object.keys(schedulesForPostOffices)[i]
            if (this.postoffices.hasOwnProperty(currentOfficeId)) {
              this.postoffices[currentOfficeId].scadule = schedulesForPostOffices[currentOfficeId]
              resultOfficesArray.push(this.postoffices[currentOfficeId]);
            }
          }
          if (resultOfficesArray.length == 0) {

            let office = this.postoffices[Object.keys(this.postoffices)[0]]
            let selectScadule = schaduleDays.filter(function (day) {

              return day.POSTCODE == office.POSTCODE
            })
            this.postoffices[Object.keys(this.postoffices)[0]].scadule = selectScadule;
            resultOfficesArray.push(this.postoffices[Object.keys(this.postoffices)[0]]);

          }
          this.postOfficeInfo.next(resultOfficesArray)
        } else {
          // add empty scadule
          this.postoffices[Object.keys(this.postoffices)[0]].scadule = [];
          this.postOfficeInfo.next([this.postoffices[Object.keys(this.postoffices)[0]]])

        }

      });

  }

  public getScheduleVpzById(id: string, postCode: number) {

    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': ''
      })
    };
    
    // let address = this.isBuildForProd ?
    //   this.api_url + `?method=get_postoffices_openhours_by_id&id=${id}` :
    //   'https://www.ukrposhta.ua/address-classifier/get_postoffices_openhours_by_id?id=' + id;

    let address: string = 'https://www.ukrposhta.ua/address-classifier/get_postoffices_openhours_by_id?id=' + id;
    // let address: string = '';

    // https://ukrposhta.ua/address-classifier/get_postoffices_openhours_by_id?id=6855

    this.http.get(address)
    .subscribe((resp: any) => {
      let filteredOfficesArray = this.unwrapResponseToArray(resp);
      let schaduleDays = filteredOfficesArray.filter(day => day.POSTCODE === postCode);
      let resultOfficesArray = [];
      let groupedSchedules = {};

      if (schaduleDays) {
        let schedulesForPostOffices = {}

        // add schedule to postoffice object
        for (let i = 0; i < Object.keys(schedulesForPostOffices).length; ++i) {
          let currentOfficeId = Object.keys(schedulesForPostOffices)[i]
          
          if (this.postoffices.hasOwnProperty(currentOfficeId)) {
            this.postoffices[currentOfficeId].scadule = schedulesForPostOffices[currentOfficeId]
            resultOfficesArray.push(this.postoffices[currentOfficeId]);
          }
        }
        if (resultOfficesArray.length == 0) {

          // group by DAYS_PERIOD
          schaduleDays.forEach((day) => {
            if (!groupedSchedules[day.DAYS_PERIOD]) {
              groupedSchedules[day.DAYS_PERIOD] = [];
            }
            groupedSchedules[day.DAYS_PERIOD].push(day);
          });

          this.postoffices[Object.keys(this.postoffices)[0]].scadule = Object.entries(groupedSchedules);
          resultOfficesArray.push(this.postoffices[Object.keys(this.postoffices)[0]]);

        }
        this.postOfficeInfo.next(resultOfficesArray)

      } else {
        // add empty scadule
        this.postoffices[Object.keys(this.postoffices)[0]].scadule = [];
        this.postOfficeInfo.next([this.postoffices[Object.keys(this.postoffices)[0]]])

      }

    });

  }

  public addInputCityToSubscribers(inputID: string): BehaviorSubject<MatchCities> {

    let initEmptyCity: MatchCities = {
      cities: undefined,
      citiesCount: undefined,
      controlID: undefined,
      cityPrefix: undefined,
      isPrefixMatchOnlyOneCity: undefined
    };

    if (this.subscribedCityInputs[inputID] == undefined)
      this.subscribedCityInputs[inputID] = new BehaviorSubject<MatchCities>(initEmptyCity);

    return this.subscribedCityInputs[inputID];

  }

  public isContainOnlyUkrainianLatters(str: string) {
    return /^[абвгґдежзийклмнопрстуфхцчшщьюяіїєІЇЄ'` -АБВГҐДЕЖЗИЙКЛМНОПРСТУФХЦЧШЩЬЮЯ.]+$/.test(str);
  }

  public replaceToSQLApostraph(value) {
    let sqlApostraph = String.fromCharCode(146);
    let correct = value.replace('`', sqlApostraph);
    correct = value.replace('\'', sqlApostraph);
    return correct;
  }

  public getStreetsByIndexMakeStreetsObject(postCode: number) {

    let address = this.isBuildForProd ?
      this.api_url + `?method=get_address_by_postcode&postcode=${postCode}&lang=UA` :
      `https://l-www.ukrposhta.loc/get-post-indexes?postcode=${postCode}&lang=UA`;
    this.http.get(address)
      .subscribe((resp: any) => {

        let streetsArray = [];
        resp = this.unwrapResponseToArray(resp)

        if (resp != undefined && resp.length > 0) {

          let streets = {};
          for (let street of resp) {
            let streetNameWithStreetType = street.STREET_NAME + " " + street.SHORTSTREETTYPE_NAME;

            if (!streets.hasOwnProperty(streetNameWithStreetType)) {
              // no such street yet
              streets[streetNameWithStreetType] = {
                oldStreetName: '',
                houses: [],
                housesString: ''
              };

            }

            streets[streetNameWithStreetType].oldStreetName = (street.OLDSTREET_NAME && street.OLDSTREET_NAME.trim) ? street.OLDSTREET_NAME : '';
            streets[streetNameWithStreetType].haveOldStreetName = (street.OLDSTREET_NAME && street.OLDSTREET_NAME.trim) ? true : false;
            streets[streetNameWithStreetType].houses.push(street.HOUSENUMBER);
            streets[streetNameWithStreetType].housesString += street.HOUSENUMBER + ", ";
            streets[streetNameWithStreetType].name = street.STREET_NAME;
            streets[streetNameWithStreetType].type = street.SHORTSTREETTYPE_NAME;
            streets[streetNameWithStreetType].location = street.REGION_NAME + " обл., " + street.DISTRICT_NAME + " р-н., " + street.CITY_NAME + " " + street.CITYTYPE_NAME
          }

          // delete last ","
          for (let street in streets) {
            streets[street].housesString = streets[street].housesString.slice(0, -2);
          }

          // create array from object
          for (let street in streets) {
            streetsArray.push(streets[street]);
          }

        }
        this.streetsInfo.next(streetsArray);
      });

  }

  public getStreetsByIndex(postCode: number) {

    let address = this.isBuildForProd ?
      this.api_url + `?method=get_address_by_postcode&postcode=${postCode}&lang=UA` :
      `https://l-www.ukrposhta.loc/get-post-indexes?postcode=${postCode}&lang=UA`;
    this.http.get(address)
      .subscribe((resp: any) => {

        this.streetsByPostIndex.next(resp);
      });

  }




}
